module.exports = __webpack_public_path__ + "0bd904a482e6227faba79ea7dd544b25.png";